/**
 * DEV-1093. Ответы квиза лендинга в карточке клиента: мотивации покупки, срок
 * решения, доля первоначального взноса и площадка-источник.
 *
 * Overlay-модуль поверх базовых локалей. Формулировки намеренно совпадают с
 * вопросами квиза — менеджер должен узнавать в карточке ровно то, что видел
 * клиент. Раньше «жизнь или сезонное проживание» показывалось как «для
 * проживания», а «рост стоимости» и «сохранение капитала» — как «инвестиция».
 */
export const quizFieldsMessages = {
  ru: {
    clients: {
      form: { downPaymentPercent: 'Первоначальный взнос' },
      detail: { landingSlug: 'Лендинг' },
      enums: {
        purchaseGoal: {
          living: 'Жизнь или сезонное проживание',
          valueGrowth: 'Рост стоимости',
          capitalPreservation: 'Сохранение капитала',
          combined: 'Жизнь и аренда',
          marketResearch: 'Изучает рынок',
        },
        dealTimeline: {
          oneToThreeMonths: '1–3 месяца',
          later: 'Позже',
          researching: 'Срок не определён',
        },
      },
    },
  },
  en: {
    clients: {
      form: { downPaymentPercent: 'Down payment' },
      detail: { landingSlug: 'Landing' },
      enums: {
        purchaseGoal: {
          living: 'Living or seasonal stay',
          valueGrowth: 'Value growth',
          capitalPreservation: 'Capital preservation',
          combined: 'Living and renting out',
          marketResearch: 'Exploring the market',
        },
        dealTimeline: {
          oneToThreeMonths: '1–3 months',
          later: 'Later',
          researching: 'No timeline yet',
        },
      },
    },
  },
  vn: {
    clients: {
      form: { downPaymentPercent: 'Thanh toán ban đầu' },
      detail: { landingSlug: 'Trang đích' },
      enums: {
        purchaseGoal: {
          living: 'Để ở hoặc lưu trú theo mùa',
          valueGrowth: 'Tăng giá trị',
          capitalPreservation: 'Bảo toàn vốn',
          combined: 'Vừa ở vừa cho thuê',
          marketResearch: 'Đang tìm hiểu thị trường',
        },
        dealTimeline: {
          oneToThreeMonths: '1–3 tháng',
          later: 'Muộn hơn',
          researching: 'Chưa xác định thời hạn',
        },
      },
    },
  },
}
